import React from 'react'
import cx from 'classnames'

interface TableRowProps {
  children: React.ReactNode
  onClick?: () => void
}

const TableRow = ({ children, onClick }: TableRowProps) => {
  return (
    <tr
      className={cx('table-row', { 'is-clickable': onClick })}
      onClick={onClick}
      tabIndex={onClick ? 0 : -1}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          onClick?.()
        }
      }}
      role={onClick ? 'button' : undefined}
    >
      {children}
    </tr>
  )
}

export default TableRow
